/* ============================================================
   tz-shop.js — Storefront interactions for TrinkspielZone.
   - Wishlist (localStorage)
   - Drawer toggle system (cart, wishlist, mobile-menu)
   - Mega-menu hover (handled via CSS)
   ============================================================ */

(function () {
  'use strict';

  // ── Wishlist (localStorage) ───────────────────────────
  var WISH_KEY = 'tz_wishlist_v1';

  function loadList() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function syncButtons(list) {
    document.querySelectorAll('[data-tz-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var on = list.indexOf(id) !== -1;
      btn.setAttribute('data-active', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Von Wishlist entfernen' : 'Zur Wishlist hinzufügen');
    });
    var count = list.length;
    document.querySelectorAll('[data-tz-wishlist-count]').forEach(function (el) {
      el.textContent = count || '';
      el.hidden = count === 0;
    });
  }
  function toggle(id) {
    var list = loadList();
    var idx = list.indexOf(id);
    if (idx > -1) list.splice(idx, 1);
    else list.push(id);
    saveList(list);
    syncButtons(list);
    // Also refresh wishlist drawer content if open
    renderWishlistDrawer(list);
    renderWishlistPage(list);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tz-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    toggle(id);
  });

  // ── Drawer system ─────────────────────────────────────
  // Each drawer is a fixed-position panel with a backdrop.
  // Open via [data-tz-open="cart" | "wishlist" | "menu"]
  // Close via [data-tz-close] or backdrop click
  function openDrawer(name) {
    closeAllDrawers();
    var drawer = document.querySelector('[data-tz-drawer="' + name + '"]');
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    var bd = document.querySelector('[data-tz-backdrop]');
    if (bd) bd.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    if (name === 'wishlist') renderWishlistDrawer(loadList());
  }
  function closeDrawer(name) {
    var drawer = document.querySelector('[data-tz-drawer="' + name + '"]');
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }
  function closeAllDrawers() {
    document.querySelectorAll('[data-tz-drawer][data-open="true"]').forEach(function (d) {
      d.setAttribute('data-open', 'false');
    });
    var bd = document.querySelector('[data-tz-backdrop]');
    if (bd) bd.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest && e.target.closest('[data-tz-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(openBtn.getAttribute('data-tz-open'));
      return;
    }
    var closeBtn = e.target.closest && e.target.closest('[data-tz-close]');
    if (closeBtn) {
      e.preventDefault();
      closeAllDrawers();
      return;
    }
    var backdrop = e.target.closest && e.target.closest('[data-tz-backdrop]');
    if (backdrop) {
      e.preventDefault();
      closeAllDrawers();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  // ── Custom events from other modules (e.g. tz-pdp.js) ──
  // tz:open-drawer  → detail: drawer name ("cart" | "wishlist" | "menu")
  // tz:cart-updated → detail: full Shopify cart object (item_count etc.)
  document.addEventListener('tz:open-drawer', function (e) {
    if (e && e.detail) openDrawer(e.detail);
  });
  document.addEventListener('tz:cart-updated', function (e) {
    var cart = e && e.detail;
    if (!cart) return;
    document.querySelectorAll('[data-tz-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count || '';
      el.hidden = !cart.item_count;
    });
    // If the cart-drawer is open, ask it to re-render (cart-drawer section listens).
    document.dispatchEvent(new CustomEvent('tz:cart-render-request', { detail: cart }));
  });

  // ── Wishlist drawer content (dynamic from localStorage) ──
  // The drawer markup has [data-tz-wishlist-empty], [data-tz-wishlist-list].
  // Product info comes from window.TZ_WISHLIST_DATA (a map of id → product).
  function renderWishlistDrawer(list) {
    var drawer = document.querySelector('[data-tz-drawer="wishlist"]');
    if (!drawer) return;
    var listEl = drawer.querySelector('[data-tz-wishlist-list]');
    var emptyEl = drawer.querySelector('[data-tz-wishlist-empty]');
    var countEl = drawer.querySelector('[data-tz-wishlist-drawer-count]');
    if (countEl) countEl.textContent = list.length;
    if (!list.length) {
      if (emptyEl) emptyEl.hidden = false;
      if (listEl) listEl.innerHTML = '';
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (!listEl) return;
    var data = window.TZ_WISHLIST_DATA || {};
    listEl.innerHTML = list.map(function (id) {
      var p = data[id];
      if (!p) {
        // Fallback for products without data
        return '<div class="tz-drw-item"><div class="tz-drw-item__media" style="background: var(--tz-navy-50);"></div>' +
          '<div class="tz-drw-item__body"><p class="tz-drw-item__name">' + id + '</p>' +
          '<button class="tz-drw-item__remove" data-tz-wishlist-toggle data-product-id="' + id + '">Entfernen</button></div></div>';
      }
      return '<a class="tz-drw-item" href="' + (p.url || '#') + '">' +
        '<div class="tz-drw-item__media"><img src="' + (p.img || '') + '" alt=""></div>' +
        '<div class="tz-drw-item__body">' +
        '<p class="tz-drw-item__name">' + p.name + '</p>' +
        (p.price ? '<p class="tz-drw-item__price">' + p.price + '</p>' : '') +
        '<button type="button" class="tz-drw-item__remove" data-tz-wishlist-toggle data-product-id="' + id + '" onclick="event.preventDefault();event.stopPropagation();">Entfernen</button>' +
        '</div></a>';
    }).join('');
  }

  // ── Wishlist PAGE content (/pages/wishlist) ──────────────
  // Same store (tz_wishlist_v1) + same product map (TZ_WISHLIST_DATA) as the drawer,
  // so the page always matches the heart/drawer state. Markup hooks:
  // [data-tz-wishlist-page-list], [data-tz-wishlist-page-empty], [data-tz-wishlist-page-count].
  function renderWishlistPage(list) {
    var grid = document.querySelector('[data-tz-wishlist-page-list]');
    if (!grid) return;
    var emptyEl = document.querySelector('[data-tz-wishlist-page-empty]');
    var countEl = document.querySelector('[data-tz-wishlist-page-count]');
    if (countEl) countEl.textContent = list.length;
    if (!list.length) {
      grid.hidden = true; grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    grid.hidden = false;
    var data = window.TZ_WISHLIST_DATA || {};
    grid.innerHTML = list.map(function (id) {
      var p = data[id];
      if (!p) {
        return '<div class="tz-wishlist-page__card">' +
          '<div class="tz-wishlist-page__card-body">' +
          '<p class="tz-wishlist-page__card-name">' + id + '</p>' +
          '<button type="button" class="tz-wishlist-page__remove" data-tz-wishlist-toggle data-product-id="' + id + '">Entfernen</button>' +
          '</div></div>';
      }
      return '<div class="tz-wishlist-page__card">' +
        '<a class="tz-wishlist-page__card-media" href="' + (p.url || '#') + '"><img src="' + (p.img || '') + '" alt="" loading="lazy"></a>' +
        '<div class="tz-wishlist-page__card-body">' +
        '<a class="tz-wishlist-page__card-name" href="' + (p.url || '#') + '">' + p.name + '</a>' +
        (p.price ? '<p class="tz-wishlist-page__card-price">' + p.price + '</p>' : '') +
        '<button type="button" class="tz-wishlist-page__remove" data-tz-wishlist-toggle data-product-id="' + id + '">Entfernen</button>' +
        '</div></div>';
    }).join('');
  }

  // ── Cart-Drawer Qty +/- (preview demo) ────────────────
  document.addEventListener('click', function (e) {
    var inc = e.target.closest && e.target.closest('[data-tz-qty-inc]');
    var dec = e.target.closest && e.target.closest('[data-tz-qty-dec]');
    if (!inc && !dec) return;
    e.preventDefault();
    var item = (inc || dec).closest('.tz-drw-item');
    if (!item) return;
    var input = item.querySelector('[data-tz-qty]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    if (inc) v++;
    if (dec) v = Math.max(1, v - 1);
    input.value = v;
  });

  // ── Initial sync ──────────────────────────────────────
  function init() { syncButtons(loadList()); renderWishlistPage(loadList()); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Smart-sticky header (Fuga-style): desktop always fixed; mobile hides on scroll-down, shows on scroll-up. ── */
(function () {
  var hdr = document.querySelector('.tz-hdr');
  if (!hdr) return;
  function setPad() {
    var h = hdr.offsetHeight;
    document.documentElement.style.setProperty('--tz-hdr-h', h + 'px');
    document.body.style.paddingTop = h + 'px'; /* inline beats any stylesheet override (tz-index.css) */
  }
  setPad();
  window.addEventListener('resize', setPad, { passive: true });
  var lastY = window.scrollY || 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY || 0;
    var isMobile = window.innerWidth < 1024;
    if (isMobile && y > lastY && y > hdr.offsetHeight) {
      hdr.classList.add('tz-hdr--hidden');
    } else {
      hdr.classList.remove('tz-hdr--hidden');
    }
    lastY = y;
  }, { passive: true });
})();

/* --- Digital-Consent Gate: Kasse nur mit Haken, wenn App-Code im Warenkorb --- */
(function(){
  function findBox(from){
    var el=from;
    while(el&&el!==document.body){
      var b=el.querySelector&&el.querySelector('input[data-tz-digital-consent]');
      if(b)return b;
      el=el.parentElement;
    }
    return document.querySelector('input[data-tz-digital-consent]');
  }
  document.addEventListener('click',function(e){
    var go=e.target.closest&&e.target.closest('a.tz-cart__cta,button[name="checkout"]');
    if(!go)return;
    var b=findBox(go);
    if(b&&!b.checked){
      e.preventDefault();e.stopPropagation();
      var w=b.closest('.tz-cart__digital-consent');if(w)w.classList.add('is-attention');
      var h=(w&&w.parentElement.querySelector('[data-tz-digital-hint]'))||document.querySelector('[data-tz-digital-hint]');
      if(h)h.hidden=false;
      b.focus();
    }
  },true);
  document.addEventListener('change',function(e){
    if(!e.target.matches||!e.target.matches('input[data-tz-digital-consent]'))return;
    var w=e.target.closest('.tz-cart__digital-consent');if(w)w.classList.remove('is-attention');
    var h=(w&&w.parentElement.querySelector('[data-tz-digital-hint]'))||document.querySelector('[data-tz-digital-hint]');
    if(h)h.hidden=e.target.checked;
    var on=e.target.checked;
    document.querySelectorAll('input[data-tz-digital-consent]').forEach(function(i){ if(i!==e.target)i.checked=on; });
    tzSyncConsent(on);
  });
  /* Zustimmung als Cart-Attribut dokumentieren (nur sichtbar, wenn App-Produkt im Warenkorb = Checkbox existiert) */
  function tzConsentValue(on){
    return on ? 'Ja \u2013 Checkbox best\u00e4tigt ' + new Date().toISOString() : null;
  }
  function tzSyncConsent(on){
    var val = tzConsentValue(on);
    document.querySelectorAll('input[data-tz-digital-consent-attr]').forEach(function(i){ i.value = val || ''; });
    var attrs = {}; attrs['Digital-Zustimmung (Widerruf erlischt)'] = val;
    window.__tzConsentSync = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(){ window.__tzConsentSynced = on; }).catch(function(){});
    return window.__tzConsentSync;
  }
  /* Express-Buttons (PayPal/Shop Pay) ausblenden, solange der Widerrufs-Haken fehlt */
  function tzToggleExpress(){
    var boxes=Array.prototype.slice.call(document.querySelectorAll('input[data-tz-digital-consent]'));
    var block=boxes.length>0&&!boxes.some(function(b){return b.checked;});
    document.querySelectorAll('.additional-checkout-buttons').forEach(function(el){
      if(block){el.style.setProperty('display','none','important');}else{el.style.removeProperty('display');}
    });
  }
  document.addEventListener('change',function(e){
    if(e.target.matches&&e.target.matches('input[data-tz-digital-consent]'))tzToggleExpress();
  });
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',tzToggleExpress);}else{tzToggleExpress();}
  setTimeout(tzToggleExpress,1000);setTimeout(tzToggleExpress,3000);
  /* Drawer-CTA ist ein Link: vor dem Absprung sicherstellen, dass das Attribut gespeichert ist */
  document.addEventListener('click',function(e){
    var go=e.target.closest&&e.target.closest('a.tz-cart__cta');
    if(!go)return;
    var b=findBox(go);
    if(b&&b.checked&&!window.__tzConsentSynced){
      e.preventDefault();e.stopPropagation();
      var dest=go.getAttribute('href')||'/checkout';
      tzSyncConsent(true).then(function(){window.location.href=dest;},function(){window.location.href=dest;});
    }
  },true);
})();
